


















































import { Component, Vue, Prop } from "vue-property-decorator";
import axios from "axios";
@Component({})
export default class Name extends Vue {
  private data: any = {
    paper_title: "针灸草药挽救衰退的卵巢功能！",
    paper_intro: "针灸草药挽救衰退的卵巢功能！",
    paper_content:
      "随着生活节奏的加快和人们生活习惯的改变，卵巢早衰(POF)的发病率越来越高。卵巢早衰可以导致不孕不育，可以让女人过早的绝经，从而过早的衰老，而伴随出现的潮热、盗汗、烦躁易怒更是让女性痛苦不堪。作为一种妇科疑难病症，卵巢早衰治疗起来难度很大，目前临床尚未找到一种被医疗界统一认可的安全、有效的治疗方案。所以对于广大女性朋友来说，重要的是了解本病的危险因素，在生活中尽量避免，从而预防本病的发生。虽然一部分卵巢早衰存在先天性的因素，平时无法避免，但大部分成熟女性的卵巢功能受多种因素影响。其中，最常见的危险因素是人工流产。人工流产可导致机体正常妊娠激素水平变化，这一变化可导致下丘脑—垂体—卵巢轴的功能紊乱，进而导致卵巢内存留卵泡数量及质量下降，促性腺激素受体的敏感性降低、卵泡发育受限，最终导致卵泡刺激素升高。而高水平的FSH可进一步抑制卵泡功能，造成月经稀少、闭经的发生。同时，多次人工流产可增强女性焦虑、抑郁情绪，而这些不良情绪对下丘脑—垂体—卵巢轴功能的负面影响又可加速卵巢功能衰退。其次，还有一些病毒和药物可以引起卵巢不可逆的损伤。比如腮腺炎病毒，不但可以损伤腮腺，还可以破坏卵巢、睾丸性腺组织。中药雷公藤和很多化疗药也可以损伤卵巢，而且这些损伤多是不可逆的，一旦让卵巢萎缩，就很难再恢复了，所以得了腮腺炎一定不能大意，要及早治疗。药物也不能乱用，一定要要根据实际情况在医生的指导下服药。下一个危险因素是抽烟。很多女性认为抽烟可以缓解紧张情绪，但也会降低卵巢功能，导致不孕。大量研究证实，烟草中的有害物质可导致卵巢、垂体组织发生不同程度的损伤，引起卵巢储备功能的下降，而下丘脑—垂体—卵巢轴功能受损可间接加速卵泡的闭锁与损耗,加速卵巢组织细胞进行性死亡,最终导致卵巢功能衰竭。还有一个危险因素那就是缺乏睡眠。长期的熬夜或睡眠质量差可导致性激素水平下降，使POF的发生风险上升。而POF的发生可进一步导致睡眠质量下滑、情绪焦虑加剧，形成恶性循环，继而造成病情恶化。几天睡不好，面色就黯沉，身体就虚乏，可见睡眠对人体健康有多么重要！等身体透支的时候，想弥补就困难啦。接下来是心理应激。像高工作生活压力等较强的心理应激状态可导致自主神经系统、内分泌系统及神经递质产生不良变化，影响内分泌功能，引起卵巢早衰。卵巢早衰在城市女性的发病率更高，跟大城市紧张的工作和生活节奏有关。有些女性一边治疗，一边还放不下忙碌的工作，这样治疗效果会大打折扣的。总之，卵巢早衰的发生与生活习惯、心理状态等因素具有密切关联。为了健康为了美，更是为了两人能结出硕果，请在生活中避免以上的不良因素吧。健康和美丽是自己的，是挣多少钱都买不回来的！中医认为卵巢早衰的基本病机是肾精亏虚，可表现为肾阴虚、肾阳虚或肾阴阳两虚。肾司生殖，闭经是生殖功能低下或丧失的标志。由于卵巢早衰的病程比较长，肾气无法推动经血化生及正常下注冲任，因此大多同时表现为经血瘀滞，比如经期小腹部疼痛、怕凉、月经量少色暗多血块等等。本病虚者多而实者少，肾虚血瘀是致病之本。因此对于卵巢早衰的治疗要注意扶正培本、化瘀通经：首先要治病求本，始终以滋肾填精为首要任务，若以潮热、怕热、闭经或月经提前为主要表现，以滋补肾阴为主，可选女贞子、墨旱莲、桑葚、熟地、枸杞子、五味子、覆盆子等滋补肾阴药为主，少加用巴戟天、菟丝子、韭菜子等药以温补肾阳，若以怕冷、四肢凉、腰酸腹凉等肾阳虚为主的，应以巴戟天、淫羊藿、仙茅、葫芦巴、菟丝子等补肾阳药为主，少加用女贞子、旱莲草滋补肾阴，以达阴中求阳之目的，恢复肾气。除了单纯中药，还可以采用针刺和艾灸。中药以补益肾精为主，针灸在恢复下丘脑—垂体—卵巢轴的正常功能方面效果比较显著。患者还可以每天交替艾灸肾俞穴、关元穴、三阴交穴，艾灸还可以更直接地作用于穴位和小腹部局部，激发卵巢功能恢复，促进月经、孕育功能及其他身体机能的恢复。卵巢功能早衰的患者，在看西医的同时，不妨来试试针灸和草药吧！（图片素材来自网络）供稿：郝洋审稿：刘炜宏",
    tags: [],
  };
  private async save() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      paper_title: this.data.paper_title,
      paper_intro: this.data.paper_intro,
      paper_content: this.data.paper_content,
    };
    try {
      // 发送 POST 请求
      const response = await axios.post(
        "http://demo.zywxg.com/PaperLabeling",
        params
      );
      loading.close();
    } catch (error: any) {
      loading.close();
      this.$message.error(error);
    }
  }
}
